import {URL_BASE_API } from '../../../configs/urlConfigs';

import service from '../../api';

const superSkillURL = 'super-admin/skill_v2/'; // ADDED ON 12Aug2022
const superActiveSkillURL = 'super-admin/active_skill_v2/'; // ADDED ON 12Aug2022 : TO LIST ACTIVE SKILLS ONLY FROM SUPERADMIN


export const skillList = (request) => {
    let ENDPOINT = '';
    if(request.data!==undefined){      
      let pageId   = request.data.page;
      let column   = request.data.column;
      let pageSize = request.data.pageSize;
      if(column||pageId||pageSize){
        // ENDPOINT = URL_BASE_API+'super-admin/skill/?page='+pageId+'&column='+column+'&page_size='+pageSize;
        if(request?.data?.activeOnly) {
          ENDPOINT = URL_BASE_API+superActiveSkillURL+'?page='+pageId+'&column='+column+'&page_size='+pageSize;
        }
        else {
          ENDPOINT = URL_BASE_API+superSkillURL+'?page='+pageId+'&column='+column+'&page_size='+pageSize;
        }
      }
    }
    return service.get(ENDPOINT);    
};


export const skillAdd = (request) => {
  // const ENDPOINT = URL_BASE_API+'super-admin/skill/'; 
  const ENDPOINT = URL_BASE_API+superSkillURL; 

  return service.post(ENDPOINT,request.data);  
};

export const skillEdit = (request) => {
  let skillId = request.data;
  //const ENDPOINT = URL_BASE_API+'super-admin/skill/'+skillId;
  const ENDPOINT = URL_BASE_API+superSkillURL+skillId;

  return service.get(ENDPOINT);  
  
};

export const skillUpdate = (request) => {
  let skillId = request.data.id;
  const ENDPOINT = URL_BASE_API+superSkillURL+skillId;

  return service.put(ENDPOINT,request.data);
 
};

export const skillDelete = (request) => {
  const ENDPOINT = URL_BASE_API+superSkillURL+request.data;

  return service.delete(ENDPOINT);  
};  

export const subSectorList = (request) => {
  // let skillId = request.data;
  const ENDPOINT = URL_BASE_API+'super-admin/subsectorlist_v2/';
  return service.get(ENDPOINT);  
};
